import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

const SpinnerNew = ({ open, text = "" }) => {
  const openSpinner = open === undefined ? false : open;
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: 9999 }} // Define a high zIndex value
      open={openSpinner}
    >
      <div
        style={{
          placeItems: "center",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <CircularProgress color="inherit" />
        {text !== "" && (
          <Typography variant="h5" gutterBottom>
            {text}
          </Typography>
        )}
      </div>
    </Backdrop>
  );
};

export default SpinnerNew;
